var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.value)?_c('v-chip',_vm._b({attrs:{"label":"","color":"edit_icon","outlined":""},on:{"click":function($event){return _vm.onNotion(_vm.value)}}},'v-chip',_vm.$attrs,false),[_c('span',[_vm._v("N")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }